import React, { useState } from 'react';
import { tp } from 'app/utils/typograf';
import classNames from 'classnames';
import { isStandaloneApp } from 'app/utils/browser';
import css from './offerGuard.module.scss';

export const OfferPopup = ({ onAccept, isScalable, isAuthed }: any) => {
    const rootClasses = classNames({
        [css.offerPopupBannerRoot]: true,
        [css.scalable]: isScalable,
    });

    const target = isStandaloneApp() ? '_self' : '_blank';
    return (
        <div
            className={rootClasses}
        >
            {isAuthed ? (
                <div className={css.offerPopupBannerContent}>
                    <div className={css.offerPopupBannerText}>
                        <div className={css.offerPopupBannerTitle}>
                            Важные изменения
                        </div>
                        <div className={css.offerPopupBannerDesc}>
                            Мы обновили условия
                            {' '}
                            <a href="/offer/" target={target} className={css.underlined}>Пользовательского соглашения.</a>
                            {' '}
                            {tp.execute('Нажимая на кнопку «Принять», вы принимаете внесенные изменения')}
                        </div>
                        <button
                            className={css.offerPopupBannerButton}
                            type="button"
                            onClick={onAccept}
                        >
                            <div>Принять</div>
                        </button>
                    </div>
                </div>
            ) : (
                <div className={css.offerPopupBannerContent}>
                    <div className={css.offerPopupBannerText}>
                        <div className={css.offerPopupBannerTitle}>
                            Подтверждение согласия
                        </div>
                        <div className={css.offerPopupBannerDesc}>
                            Нажимая «Принять», вы соглашаетесь с условиями
                            {' '}
                            <a
                                href="/offer/"
                                rel="noopener noreferrer"
                                target={target}
                                className={css.underlined}
                            >
                                <span>
                                    пользовательского соглашения,
                                </span>
                            </a>
                            {' '}
                            политиками
                            {' '}
                            <a
                                href="/privacy_policy"
                                rel="noopener noreferrer"
                                target={target}
                                className={css.underlined}
                            >
                                <span>
                                    конфиденциальности,
                                </span>
                            </a>
                            {' '}
                            <a
                                href="/personal_data_policy/"
                                rel="noopener noreferrer"
                                target={target}
                                className={css.underlined}
                            >
                                <span>
                                    обработки персональных данных
                                </span>
                            </a>
                            {' '}
                            и
                            {' '}
                            <a
                                href="/mailing_policy"
                                rel="noopener noreferrer"
                                target={target}
                                className={css.underlined}
                            >
                                <span>
                                    рассылки
                                </span>
                            </a>
                        </div>
                        <button
                            className={css.offerPopupBannerButton}
                            type="button"
                            onClick={onAccept}
                        >
                            <div>Принять</div>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
